module.exports = __webpack_public_path__ + "img/sanjivani_group_logo_.515b4775.png";